export default {
  name: 'DaysView',
  props: {
    data: {
      type: String
    }
  },
  data () {
    return {
    }
  },
  computed: {
    daysData () {
      const daysObj = {
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false
      };
      const givenDays = this.data.split('');
      for (const day in daysObj) {
        if (givenDays.includes(day)) {
          daysObj[day] = true;
        }
      }
      return daysObj;
    }
  },
  methods: {
  }
}
